import { AxiosPromise } from 'axios';
import { apiV1 } from '~/services/api';
import { JSONPendingInvoiceItem } from '~/types/PendingInvoiceItem';

export type JSONPendingInvoiceItemResponse = {
  data: {
    count: number;
    results: JSONPendingInvoiceItem[];
    previous: Maybe<string>;
    next: Maybe<string>;
  };
};

export function fetchPendingInvoiceTransactions(pageNumber = 1, pageSize = 25): AxiosPromise {
  return apiV1.request({
    url: `/v1/invoice_items?unbilled=True&page=${pageNumber}&results=${pageSize}`,
    method: 'GET',
  });
}
